// extracted by mini-css-extract-plugin
export default {"root":"_3fIjQ"};